import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@nohara/react-core';
import { OrgEntity, ApiResponse } from '@nohara/oidc-core';

import { api } from '@/lib';

export const getOrg = async (orgId: string): Promise<OrgEntity> => {
  const { data } = await api.get<unknown, ApiResponse<OrgEntity>>(`/orgs/${orgId}`);
  return data;
};

export const getOrgQueryOptions = (orgId: string | undefined) => {
  return queryOptions({
    queryKey: ['orgs', orgId],
    queryFn: () => getOrg(orgId!),
    enabled: !!orgId,
  });
};

type UseOrgOptions = {
  queryConfig?: QueryConfig<typeof getOrgQueryOptions>;
};

export const useOrg = (orgId: string | undefined, { queryConfig }: UseOrgOptions = {}) => {
  return useQuery({
    ...getOrgQueryOptions(orgId),
    ...queryConfig,
  });
};
